import { toast } from "react-toastify";

import BulkAction from "common/components/BulkAction";
import { getMonthName } from "common/helpers/utils";
import type { Lead, WorkExperience } from "common/types";

export function formatMonthAndYear(data: { month: number; year: number }) {
  const { month, year } = data;
  const monthName = getMonthName(month - 1);
  if (monthName) {
    return `${monthName} ${year}`;
  }
  return year.toString();
}

export function formatRange(from: string, to: string) {
  return [from, to].filter((value) => !!value).join(" - ");
}

export function formatExperienceStartAndEnd(
  start: WorkExperience["start_date"],
  end: WorkExperience["end_date"],
) {
  return formatRange(
    start ? formatMonthAndYear(start) : "Unknown start date",
    end ? formatMonthAndYear(end) : "Present",
  );
}

export function getCompaniesFromWorkExperience(
  workExperience: WorkExperience[],
) {
  return workExperience
    ? workExperience.reduce<Record<string, WorkExperience[]>>(
        (accumulator, currentValue) => {
          const key = currentValue.company ? currentValue.company.name : "";
          if (!accumulator[key]) {
            accumulator[key] = [];
          }
          accumulator[key].push(currentValue);
          return accumulator;
        },
        {},
      )
    : {};
}

export function startLeadsBulkAction(
  actionFn: (lead: Lead, abortSignal: AbortSignal) => Promise<unknown>,
  leads: Lead[],
  renderToastTitle: (finishedItemsCount: number) => string,
  isAsync?: boolean,
) {
  toast(
    ({ closeToast }) => (
      <BulkAction<Lead>
        actionFn={actionFn}
        items={leads}
        onClose={closeToast}
        renderTitle={renderToastTitle}
        isAsync={isAsync}
        renderReviewItem={({ full_name, occupation }) => (
          <div className="flex border border-black-200 p-3 gap-x-2 rounded-3xl">
            <div className="flex min-w-0 flex-col gap-y-1">
              <h5 className="line-clamp-1 break-all text-md-bold">
                {full_name}
              </h5>
              {occupation ? (
                <span className="line-clamp-1 break-all text-button-xs text-black-500">
                  {occupation}
                </span>
              ) : null}
            </div>
          </div>
        )}
      />
    ),
    {
      position: "bottom-right",
      autoClose: false,
      closeButton: false,
      icon: false,
    },
  );
}
